/* OH FRIDAY — drop clock, friday list popup, product page. */
(function () {
  'use strict';
  var root = document.documentElement;
  var OHF = window.OHF;
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function each(sel, scope, fn) { Array.prototype.forEach.call((scope || document).querySelectorAll(sel), fn); }
  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* 1. Drop clock: state, countdowns ------------------------------------ */
  function setUnit(cd, unit, value) {
    var el = cd.querySelector('[data-oh-unit="' + unit + '"]');
    if (el && el.textContent !== value) el.textContent = value;
  }
  function tick() {
    if (!OHF) return;
    var now = Date.now();
    var s = OHF.compute(now);
    if (root.getAttribute('data-oh-state') !== s.state) OHF.apply(s);
    var secs = Math.max(0, Math.floor((s.target - now) / 1000));
    var d = Math.floor(secs / 86400);
    var h = Math.floor((secs % 86400) / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var sec = secs % 60;
    each('[data-oh-cd]', document, function (cd) {
      var long = !!cd.querySelector('[data-oh-unit="d"]');
      setUnit(cd, 'd', pad(d));
      setUnit(cd, 'h', pad(long ? h : Math.floor(secs / 3600)));
      setUnit(cd, 'm', pad(m));
      setUnit(cd, 's', pad(sec));
    });
    var left = Math.max(0, Math.floor(((s.end || s.target) - now) / 1000));
    var txt = left >= 3600
      ? Math.floor(left / 3600) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60)
      : pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    each('[data-oh-mmss]', document, function (el) { if (el.textContent !== txt) el.textContent = txt; });
  }
  tick();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });

  /* 2. Bag count + toast ------------------------------------------------ */
  function setBag(n) {
    each('[data-oh-bag-count]', document, function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    each('[data-oh-bag]', document, function (a) { a.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function toast(text) {
    var t = document.querySelector('.oh-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'oh-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span></span><a href="' + cartRoot + 'cart">view bag</a>';
      document.body.appendChild(t);
    }
    t.querySelector('span').textContent = text;
    t.hidden = false;
    clearTimeout(t._hide);
    t._hide = setTimeout(function () { t.hidden = true; }, 5000);
  }

  /* 3. Money ------------------------------------------------------------ */
  function money(cents, format) {
    var fmt = format || '{{amount_with_comma_separator}} €';
    var val = cents / 100;
    var whole = cents % 100 === 0;
    function f(n, dec, thou, decSep) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p.length > 1 ? p[0] + decSep + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return f(val, whole ? 0 : 2, ',', '.');
        case 'amount_no_decimals': return f(val, 0, ',', '.');
        case 'amount_with_comma_separator': return f(val, whole ? 0 : 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(val, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(val, whole ? 0 : 2, "'", '.');
        case 'amount_with_space_separator': return f(val, whole ? 0 : 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return f(val, whole ? 0 : 2, ' ', '.');
        default: return f(val, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* 4. Product page ----------------------------------------------------- */
  function initProduct(sec) {
    if (sec._oh) return;
    sec._oh = true;
    var dataEl = sec.querySelector('[data-oh-product-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = sec.querySelector('form.oh-form');
    var idInput = sec.querySelector('[data-oh-variant-id]');
    var inputs = sec.querySelectorAll('[data-oh-opt]');
    var addBtn = sec.querySelector('[data-oh-add]');
    var addLabel = sec.querySelector('[data-oh-add-label]');
    var msg = sec.querySelector('[data-oh-add-msg]');
    var priceNow = sec.querySelector('[data-oh-price-now]');
    var priceLater = sec.querySelector('[data-oh-price-later]');
    var track = sec.querySelector('[data-oh-track]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mark(i) {
      each('[data-oh-thumb]', sec, function (b) { b.setAttribute('aria-current', +b.getAttribute('data-oh-thumb') === i ? 'true' : 'false'); });
      each('.oh-gallery__dots span', sec, function (dot, k) { dot.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function goTo(i) {
      if (!track || !track.children[i]) return;
      track.scrollTo({ left: track.children[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    each('[data-oh-thumb]', sec, function (b) {
      b.addEventListener('click', function () { goTo(+b.getAttribute('data-oh-thumb')); });
    });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
      }, { passive: true });
    }

    function selected() {
      var opts = [];
      Array.prototype.forEach.call(inputs, function (i) { if (i.checked) opts[+i.getAttribute('data-oh-opt')] = i.value; });
      return opts;
    }
    function match(opts) {
      for (var k = 0; k < data.variants.length; k++) {
        var v = data.variants[k];
        var ok = true;
        for (var j = 0; j < v.options.length; j++) { if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function update(fromUser) {
      if (!data.variants || !data.variants.length) return;
      var opts = selected();
      var v = inputs.length ? match(opts) : data.variants[0];
      each('[data-oh-opt-label]', sec, function (l) {
        var i = +l.getAttribute('data-oh-opt-label');
        if (opts[i]) l.textContent = opts[i];
      });
      Array.prototype.forEach.call(inputs, function (inp) {
        var k = +inp.getAttribute('data-oh-opt');
        var test = opts.slice();
        test[k] = inp.value;
        var hit = match(test);
        inp.classList.toggle('is-unavailable', !hit || !hit.available);
      });
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      var launch = v.compare_at_price && v.compare_at_price > v.price;
      if (priceNow) {
        priceNow.textContent = money(v.price, data.moneyFormat);
        priceNow.classList.toggle('oh-price__now--launch', !!launch);
      }
      if (priceLater && launch) priceLater.textContent = money(v.compare_at_price, data.moneyFormat);
      each('[data-oh-launch-only]', sec, function (el) { el.hidden = !launch; });
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? data.addLabel + ' · ' + money(v.price, data.moneyFormat) : 'sold out';
      if (fromUser) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
        if (v.featured_media && track) {
          var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (slide) goTo(Array.prototype.indexOf.call(track.children, slide));
        }
      }
    }
    Array.prototype.forEach.call(inputs, function (i) { i.addEventListener('change', function () { update(true); }); });
    update(false);

    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        addBtn.disabled = true;
        if (msg) msg.textContent = '';
        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'We could not add it. Try again.');
            return fetch(cartRoot + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            setBag(cart.item_count);
            toast('added to bag');
          })
          .catch(function (err) { if (msg) msg.textContent = err.message; })
          .then(function () { update(false); });
      });
    }
  }
  each('[data-oh-product]', document, initProduct);

  /* 5. Friday list popup ------------------------------------------------ */
  var KEY_DISMISS = 'oh_pop_dismissed';
  var KEY_JOINED = 'oh_list_joined';
  function initPop(pop) {
    if (pop._oh) return;
    pop._oh = true;
    var form = pop.querySelector('form');
    var step1 = pop.querySelector('[data-oh-step="1"]');
    var step2 = pop.querySelector('[data-oh-step="2"]');
    var done = pop.querySelector('[data-oh-step="done"]');
    var lastFocus = null;
    var sending = false;

    function visible(el) { return el && !el.hidden; }
    function open() {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      root.classList.add('oh-locked');
      setTimeout(function () {
        var target = visible(step1) ? pop.querySelector('#oh-pop-email') : pop.querySelector('.oh-pop__step:not([hidden]) [data-oh-pop-close]');
        if (target) target.focus();
      }, 40);
    }
    function close(remember) {
      pop.hidden = true;
      root.classList.remove('oh-locked');
      if (remember) store(KEY_DISMISS, String(Date.now()));
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function send(withBirthday) {
      if (sending || !form) return;
      sending = true;
      var tags = form.querySelector('[data-oh-tags]');
      if (withBirthday && tags) {
        var d = pop.querySelector('[data-oh-bday-day]');
        var m = pop.querySelector('[data-oh-bday-month]');
        if (d && m && d.value && m.value) tags.value = tags.value + ',bday-' + m.value + '-' + d.value;
      }
      store(KEY_JOINED, '1');
      HTMLFormElement.prototype.submit.call(form);
    }
    function dismiss() {
      if (visible(step2)) { send(false); return; }
      close(!done);
    }

    each('[data-oh-pop-close]', pop, function (btn) { btn.addEventListener('click', dismiss); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); dismiss(); return; }
      if (e.key !== 'Tab') return;
      var els = Array.prototype.filter.call(
        pop.querySelectorAll('.oh-pop__card a[href], .oh-pop__card button, .oh-pop__card input:not([type="hidden"]), .oh-pop__card select'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (form && step1 && step2) {
      form.addEventListener('submit', function (e) {
        if (visible(step2)) return;
        e.preventDefault();
        var email = form.querySelector('#oh-pop-email');
        if (email && !email.checkValidity()) { email.reportValidity(); return; }
        step1.hidden = true;
        step2.hidden = false;
        var title = step2.querySelector('[data-oh-step2-title]');
        if (title) title.focus();
      });
      var save = step2.querySelector('[data-oh-bday-save]');
      var skip = step2.querySelector('[data-oh-skip]');
      if (save) save.addEventListener('click', function () { send(true); });
      if (skip) skip.addEventListener('click', function () { send(false); });
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === pop.getAttribute('data-section')) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === pop.getAttribute('data-section')) close(false); });
      return;
    }
    if (done) {
      store(KEY_JOINED, '1');
      if (window.location.hash === '#oh-pop-form') open();
      return;
    }
    if (step1 && step1.hasAttribute('data-oh-error')) { open(); return; }
    if (read(KEY_JOINED)) return;
    var dismissed = +read(KEY_DISMISS) || 0;
    if (dismissed && Date.now() - dismissed < 14 * 86400000) return;
    var delay = (+pop.getAttribute('data-delay') || 8) * 1000;
    setTimeout(open, delay);
  }
  each('[data-oh-pop]', document, initPop);

  /* 6. Small things ----------------------------------------------------- */
  each('.oh-menu', document, function (menu) {
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
    each('a', menu, function (a) { a.addEventListener('click', function () { menu.open = false; }); });
  });
  document.addEventListener('click', function (e) {
    each('.oh-menu[open]', document, function (menu) { if (!menu.contains(e.target)) menu.open = false; });
  });
  each('[data-oh-focus]', document, function (el) { el.focus(); });
  if (document.querySelector('form#oh-pop-form') === null && /customer_posted=true/.test(window.location.search)) store(KEY_JOINED, '1');

  document.addEventListener('shopify:section:load', function (e) {
    each('[data-oh-product]', e.target, initProduct);
    each('[data-oh-pop]', e.target, initPop);
  });
})();
